export const SET_USER_INFO = "SET_SELECTED_LANGUAGE";
export const SET_IS_ACT_AS_USER = "SET_IS_ACT_AS_USER";

export function setUserInfo(data) {
  return {
    type: SET_USER_INFO,
    payload: data,
  };
}

export function setIsActAsUser(data) {
  return {
    type: SET_IS_ACT_AS_USER,
    payload: data,
  };
}

